import { render, staticRenderFns } from "./placement-strategy-tpl-use.vue?vue&type=template&id=89240f92&scoped=true&"
import script from "./placement-strategy-tpl-use.vue?vue&type=script&lang=js&"
export * from "./placement-strategy-tpl-use.vue?vue&type=script&lang=js&"
import style0 from "./placement-strategy-tpl-use.vue?vue&type=style&index=0&id=89240f92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89240f92",
  null
  
)

export default component.exports